import Vue from 'vue'
const vm = new Vue()

// const url_prefix = "/wisdom-portal";
const url_prefix = "";

/**
 * 通过用户账号登录
 * @param params
 * @returns {Promise<T>}
 */
export const loginByAccount = params => {
  const url = vm.$http.adornUrl(getUrl('/login/loginByAccount'))
  return vm.$http.post(url, vm.$http.adornData(params)).then((res) => res.data)
}

/**
 * 获取钉钉授权登录URL
 * @param {*} params 
 * @returns 
 */
export const getAuthUrlByDingTalk = params => {
  const url = vm.$http.adornUrl(getUrl('/login/dingtalk/authUrl'))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}

/**
 * 根据钉钉授权获取系统用户信息
 * @param {*} params 
 * @returns 
 */
export const getUserTokenByDingTalk = params => {
  const url = vm.$http.adornUrl(getUrl('/login/dingtalk/authCode'))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}

/**
 * 钉钉绑定用户
 * @param {*} params 
 * @returns 
 */
export const dingTalkBindUser = params => {
  const url = vm.$http.adornUrl(getUrl('/login/dingtalk/bind'))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}

/**
 * 公众平台通过页面code授权登录
 * @param params
 * @returns {Q.Promise<unknown>}
 */
export const loginByPcOpenid = params => {
  const url = vm.$http.adornUrl(getUrl('/login/loginByPcOpenid'))
  return vm.$http.postForm(url, params).then((res) => res.data)
}
/**
 * 退出登录
 * @param params
 * @returns {any}
 */
export const loginOut = params => {
  const url = vm.$http.adornUrl(getUrl(`/login/loginOut`))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}
/**
 * 获取应用列表
 * @param params
 * @returns {any}
 */
export const listApplication = params => {
  const url = vm.$http.adornUrl(getUrl(`/application/list4Pc`))
  params = {userId: vm.$cookie.get("userId")}
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}
/**
 * 获取用户详细信息
 * @returns {any}
 */
export const queryUserInfo = () => {
  const url = vm.$http.adornUrl(getUrl(`/user/queryUserInfo`))
  return vm.$http.get(url).then((res) => res.data)
}
/**
 * 修改用户信息
 * @param params
 * @returns {Promise<T>}
 */
export const updateUser = params => {
  const url = vm.$http.adornUrl(getUrl('/user/updateUser'))
  return vm.$http.post(url, vm.$http.adornData(params)).then((res) => res.data)
}

/**
 * 修改用户密码
 * @param params
 * @returns {Promise<T>}
 */
export const updatePassword = params => {
  const url = vm.$http.adornUrl(getUrl('/user/updatePassword'))
  return vm.$http.post(url, vm.$http.adornData(params)).then((res) => res.data)
}

/**
 * 修改手机号
 * @param params
 * @returns {Promise<T>}
 */
export const updatePhone = params => {
  const url = vm.$http.adornUrl(getUrl('/user/updatePhone'))
  return vm.$http.post(url, vm.$http.adornData(params)).then((res) => res.data)
}
/**
 * 微信解绑
 * @returns {Q.Promise<unknown>}
 */
export const unBindingPcWechat = () => {
  const url = vm.$http.adornUrl(getUrl('/user/unBindingPcWechat'))
  return vm.$http.postForm(url, {userId: vm.$cookie.get('userId')}).then((res) => res.data)
}
/**
 * 根据页面授权code查询用户
 * @param params
 * @returns {any}
 */
export const queryUserByOpenCode = params => {
  const url = vm.$http.adornUrl(getUrl(`/user/queryUserByOpenCode`))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}
/**
 * 重置密码
 * @param params
 * @returns {Promise<T>}
 */
export const resetPassword = params => {
  const url = vm.$http.adornUrl(getUrl('/user/resetPassword'))
  return vm.$http.post(url, vm.$http.adornData(params)).then((res) => res.data)
}
/**
 * 绑定微信
 * @param params
 * @returns {Q.Promise<unknown>}
 */
export const bindingPcWechat = params => {
  const url = vm.$http.adornUrl(getUrl('/user/bindingPcWechat'))
  return vm.$http.postForm(url, params).then((res) => res.data)
}

function getUrl(url) {
  return url_prefix + url;
}

export const getHelpTypeList = params => {
  const url = vm.$http.adornUrl(getUrl(`/help/type/list`))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}

export const getHelpPage = params => {
  const url = vm.$http.adornUrl(getUrl(`/help/list`))
  return vm.$http.get(url, {params: params}).then((res) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/api.js